import R from 'app/assets/R'
import { EYesNo, PaymentMethodEnum } from './enum'

const YesNoArray: EYesNo[] = [EYesNo.no, EYesNo.yes]

const DATE = {
  YYYY_MM_DD: 'YYYY-MM-DD',
  MM: 'MM',
  YYYY: 'YYYY',
  YYYYMMDD: 'YYYYMMDD',
  DDDD_D: 'dddd D',
  LT_A: 'LT A',
  LT: 'LT',
  HH_MM: 'HH:mm',
  DDDD: 'dddd',
  DD: 'DD',
  CH: 'CH',
  SA: 'SA',
  AM: 'AM',
  PM: 'PM',
  DD_MM_YYYY_HH_MM: 'DD/MM/YYYY HH:mm',
  YYYY_MM_DD_HH_MM: 'YYYY-MM-DD HH:mm',
  DD_MM_YYYY: 'DD/MM/YYYY',
}

const PAYMENT_METHOD_CONTENT = {
  [PaymentMethodEnum.Cash]: {
    i18nKeyTitle: R.strings.cash,
  },
  [PaymentMethodEnum.Bank]: {
    i18nKeyTitle: R.strings.transfer,
  },
  [PaymentMethodEnum.EWallet]: {
    i18nKeyTitle: R.strings.e_wallet,
  },
}

const CODE_REGEX = /^[a-zA-Z0-9_]+(-[a-zA-Z0-9_]+)*$/

export { DATE, YesNoArray, PAYMENT_METHOD_CONTENT, CODE_REGEX}
